export const DEFAULT_FETCH_NOTES_ATTEMPTS = 2
export const DEFAULT_FETCH_NOTES_RETRY_DELAY = 200
export const DEFAULT_SUMMARY_POLL_INTERVAL = 1000 * 3 // 3 seconds
export const DEFAULT_STOP_POLLING_DELAY = 1000 * 15 // 15 seconds
